import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { onCancel } from './handler/UserManagementHandler';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function CancelDialogAddUser({ isOpen, argsAll, submitAction, setIsOpen }) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const onCloseDialogReject = (event, reason) => {
        argsAll.setOpenCancelDialog(false);
    };

    let isEditUserChange = false;
    for (const editUser of argsAll.editUserList) {
        if (editUser?.hasChange) {
            isEditUserChange = true;
        }
    }

    const message = isEditUserChange ? trI18n('USER12MSG010') :trI18n('USER09MSG001');

    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">{message}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                    onClick={() => onCancel(argsAll)}
                >
                    {trI18n('COMBTN002')}
                </Button>

                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={onCloseDialogReject}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
